// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"624":"clere","738":"course-manager","888":"course-setup"}[chunkId] || chunkId) + "." + {"160":"6ddd7ae5","368":"046926f6","598":"eca930ca","624":"48e69565","738":"c8351735","888":"d5e3b8e3"}[chunkId] + ".css";
};